import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { BorderRadiusTokens, ColorTokens, DividerSizeTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, InputTypeToken, SizeTypeTokens, StackAlignItems, StackJustifyContent, StackPositionType, StackType, StackWidth, WIDGET, } from '@voltmoney/schema';
import { ROUTE } from '../../routes';
import { ACTION } from "./types";
import { filterAction, goBack, onChangeDimension, openInfo, st } from "./actions";
import sharedPropsService from "../../SharedPropsService";
import { addCommasToNumber, sumObjectValues } from "../../configs/utils";
let navigated = false;
export const template = async (totalPortfolio, eligiblePortfolio, eligibleLimit, customerLeadAssetDetail, isFromEligible, height) => ({
    layout: {
        id: ROUTE.CHECK_LIMIT_VIEW_DETAIL,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            { id: 'CheckLimitViewDetailRootStackHeader', type: WIDGET.STACK, position: POSITION.ABSOLUTE_TOP },
            { id: 'CheckLimitViewDetailRootStack', type: WIDGET.STACK },
        ],
    },
    datastore: {
        CheckLimitViewDetailRootStack: {
            width: StackWidth.MATCH_PARENT,
            type: StackType.column,
            widgetItems: [
                { id: 'CheckLimitViewDetailRootStack1', type: WIDGET.STACK },
                { id: "assetSearch", type: WIDGET.ASSET_SEARCH }
            ],
            dimensionAction: {
                routeId: ROUTE.CHECK_LIMIT_VIEW_DETAIL,
                type: ACTION.ON_CHANGE_DIMENSION,
                payload: {}
            }
        },
        CheckLimitViewDetailRootStack1: {
            width: StackWidth.MATCH_PARENT,
            padding: {
                left: SizeTypeTokens.XL,
                right: SizeTypeTokens.XL,
                bottom: SizeTypeTokens.XL
            },
            widgetItems: [
                { id: 'CheckLimitViewDetailRootStackSpace0', type: WIDGET.SPACE },
                { id: 'CheckLimitViewDetailTopStack', type: WIDGET.STACK },
                { id: 'CheckLimitViewDetailRootStackSpace1', type: WIDGET.SPACE },
                { id: 'CheckLimitViewDetailRootStack1Text1', type: WIDGET.TEXT },
            ]
        },
        CheckLimitViewDetailRootStack1Text1: {
            label: 'List of mutual funds',
            fontSize: FontSizeTokens.MD,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        CheckLimitViewDetailTopStack: {
            width: StackWidth.MATCH_PARENT,
            type: StackType.column,
            padding: {
                all: SizeTypeTokens.LG
            },
            borderConfig: {
                borderRadius: BorderRadiusTokens.BR2,
                borderWidth: {
                    all: SizeTypeTokens.Size1,
                },
                borderColor: ColorTokens.Grey_Chalk
            },
            widgetItems: [
                { id: 'CheckLimitViewDetailTopStackS1', type: WIDGET.STACK },
                { id: 'CheckLimitViewDetailTopStackS2', type: WIDGET.STACK },
                { id: 'CheckLimitViewDetailTopStackS3', type: WIDGET.STACK }
            ]
        },
        CheckLimitViewDetailTopStackS3: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            justifyContent: StackJustifyContent.spaceBetween,
            widgetItems: [
                { id: 'CheckLimitViewDetailTopStackS3_T1', type: WIDGET.TEXT },
                { id: 'CheckLimitViewDetailTopStackS3_T2', type: WIDGET.TEXT }
            ]
        },
        CheckLimitViewDetailTopStackS3_T1: {
            label: 'Eligible limit',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        CheckLimitViewDetailTopStackS3_T2: {
            label: `₹${eligibleLimit ? addCommasToNumber(eligibleLimit) : 0}`,
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: 24,
            color: ColorTokens.Secondary_100
        },
        CheckLimitViewDetailTopStackS2: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            padding: {
                bottom: SizeTypeTokens.MD
            },
            justifyContent: StackJustifyContent.spaceBetween,
            widgetItems: [
                { id: 'CheckLimitViewDetailTopStackS2_T1', type: WIDGET.TEXT },
                { id: 'CheckLimitViewDetailTopStackS2_T2', type: WIDGET.TEXT }
            ]
        },
        assetSearch: {
            type: InputTypeToken.SEARCH,
            dataa: customerLeadAssetDetail,
            isFromEligible: isFromEligible,
            height: height,
            action: {
                type: ACTION.FILTER,
                payload: { value: "", widgetId: "input" },
                routeId: ROUTE.CHECK_LIMIT_VIEW_DETAIL,
            },
            learnWhyAction: {
                routeId: ROUTE.CHECK_LIMIT_VIEW_DETAIL,
                type: ACTION.OPEN_INFO,
                payload: {}
            }
        },
        CheckLimitViewDetailTopStackS2_T1: {
            label: 'Eligible portfolio',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        CheckLimitViewDetailTopStackS2_T2: {
            label: `₹${eligiblePortfolio ? addCommasToNumber(eligiblePortfolio) : 0}`,
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        CheckLimitViewDetailTopStackS1: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            justifyContent: StackJustifyContent.spaceBetween,
            padding: {
                bottom: SizeTypeTokens.MD
            },
            widgetItems: [
                { id: 'CheckLimitViewDetailTopStackS1_T1', type: WIDGET.TEXT },
                { id: 'CheckLimitViewDetailTopStackS1_T2', type: WIDGET.TEXT }
            ]
        },
        CheckLimitViewDetailTopStackS1_T1: {
            label: 'Total portfolio',
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        CheckLimitViewDetailTopStackS1_T2: {
            label: `₹${totalPortfolio ? addCommasToNumber(totalPortfolio) : ''}`,
            fontSize: FontSizeTokens.SM,
            fontFamily: FontFamilyTokens.Inter,
            fontWeight: '500',
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        CheckLimitViewDetailRootStackHeader: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            // padding: {
            //     all: SizeTypeTokens.XL,
            // },
            widgetItems: [
                { id: 'CheckLimitViewDetailRootStackHeader1', type: WIDGET.STACK },
                { id: 'CheckLimitViewDetailDivider', type: WIDGET.DIVIDER }
            ]
        },
        CheckLimitViewDetailRootStackHeader1: {
            type: StackType.row,
            width: StackWidth.MATCH_PARENT,
            alignItems: StackAlignItems.center,
            padding: {
                all: SizeTypeTokens.XL,
            },
            widgetItems: [
                { id: 'CheckLimitViewDetailRootStackHeaderStack1', type: WIDGET.STACK },
                { id: 'CheckLimitViewDetailRootStackHeaderT1', type: WIDGET.TEXT }
            ]
        },
        CheckLimitViewDetailDivider: {
            size: DividerSizeTokens.SM,
            color: ColorTokens.Grey_Chalk
        },
        CheckLimitViewDetailRootStackHeaderT1: {
            label: 'Credit limit for mutual funds',
            fontSize: FontSizeTokens.MD,
            fontFamily: FontFamilyTokens.Poppins,
            fontWeight: '600',
            lineHeight: 24,
            color: ColorTokens.Grey_Night
        },
        CheckLimitViewDetailRootStackHeaderStack1: {
            width: StackWidth.CONTENT,
            position: StackPositionType.relative,
            positionConfig: {
                top: SizeTypeTokens.XS
            },
            widgetItems: [
                { id: 'CheckLimitViewDetailRootStackHeaderStack1Icon1', type: WIDGET.ICON }
            ],
            action: {
                routeId: ROUTE.CHECK_LIMIT_VIEW_DETAIL,
                type: ACTION.GO_BACK,
                payload: {}
            }
        },
        CheckLimitViewDetailRootStackHeaderStack1Icon1: {
            name: IconTokens.ChevronLeft,
            size: IconSizeTokens.MD
        },
        CheckLimitViewDetailRootStackSpace0: {
            size: SizeTypeTokens.XL
        },
        CheckLimitViewDetailRootStackSpace1: {
            size: SizeTypeTokens.XXXL
        },
    }
});
export const CheckLimitViewDetailMF = {
    onLoad: async ({ getHeight }, { isFromEligible }) => {
        const height = getHeight();
        const customerLeadAssetDetail = await sharedPropsService.getCustomerLeadAssetData();
        const availableCreditLimit = sumObjectValues(customerLeadAssetDetail?.overallSummary?.eligibleCreditLimit);
        const totalPortfolio = sumObjectValues(customerLeadAssetDetail?.overallSummary?.totalFundsSummary);
        const eligiblePortfolio = sumObjectValues(customerLeadAssetDetail?.overallSummary?.eligibleFundsSummary);
        const eligibleLimit = availableCreditLimit;
        return Promise.resolve(template(totalPortfolio, eligiblePortfolio, eligibleLimit, customerLeadAssetDetail, isFromEligible, height));
    },
    action: {
        routeId: ROUTE.CHECK_LIMIT_VIEW_DETAIL,
        type: ACTION.ON_LOAD,
        payload: {}
    },
    actions: {
        [ACTION.ON_CHANGE_DIMENSION]: onChangeDimension,
        [ACTION.GO_BACK]: goBack,
        [ACTION.FILTER]: filterAction,
        [ACTION.OPEN_INFO]: openInfo,
        [ACTION.ON_LOAD]: st
    },
};
